import { useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../config/firebase';
import defaultContent from '../data/defaultContent';

const mergeContentWithDefaults = (incoming = {}) => {
  const mergeList = (items, defaults = []) => {
    if (!Array.isArray(items)) return defaults;
    return items.map((item, index) => {
      const fallback = defaults[index] || {};
      const merged = { ...fallback, ...item };
      if (!merged.icon && fallback.icon) {
        merged.icon = fallback.icon;
      }
      return merged;
    });
  };

  return {
    ...defaultContent,
    ...incoming,
    jobs: mergeList(incoming.jobs, defaultContent.jobs),
    internships: mergeList(incoming.internships, defaultContent.internships),
    volJobs: mergeList(incoming.volJobs, defaultContent.volJobs),
    projects: mergeList(incoming.projects, defaultContent.projects),
    certificates: mergeList(incoming.certificates, defaultContent.certificates),
  };
};

export function useFirebaseContent(setContent) {
  useEffect(() => {
    const fetchContent = async () => {
      try {
        const docRef = doc(db, 'portfolio', 'content');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const parsed = docSnap.data();
          const enContent = parsed.en ? parsed.en : parsed;
          setContent(mergeContentWithDefaults(enContent));
        }
      } catch (error) {
        console.error("Firebase veri çekme hatası:", error);
      }
    };
    fetchContent();
  }, [setContent]);
}
